import { createFileRoute } from "@tanstack/react-router";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FieldGroup, Fieldset } from "src/components/base/fieldset";
import { PrimaryButton } from "src/components/base/button";
import { ApiPublic } from "src/api/api_public";
import { Text } from "src/components/base/text";

/**
 * The properties for {@link TailscaleLogin}
 */
export type TailscaleLoginProps = {};

/**
 * Login component, when a user logs in via tailscale cli
 */
export default function TailscaleLogin(props: TailscaleLoginProps) {
    const [t] = useTranslation("static");

    const preferredLogin = localStorage.getItem("preferred-tailscale-login");

    const { token } = Route.useParams();
    const data = Route.useLoaderData();

    /** redirect to oidc with the token which was granted by the backend */
    const redirectToOidc = () => {
        useEffect(() => {
            window.location.href = window.location.origin + `/api/frontend/v1/oidc/begin-login/${token}`;
        }, []);
    };

    // right now just redirect to OIDC, because right now the only login provider
    if (data.customer_oidc) {
        redirectToOidc();
    }

    if (preferredLogin) {
        if (preferredLogin === "Oidc" && data.customer_oidc) {
            redirectToOidc();
        }

        // not supported yet
        // if (preferredLogin === "External") {
        //     navigate({ to: "/s/tailscale-login/$token/external-tailscale-login", params: { token: token } }).then();
        // }
    }

    return (
        <div className={"flex flex-col items-center justify-center gap-4"}>
            <div className="w-full max-w-md rounded-xl border bg-white dark:border-zinc-800 dark:bg-zinc-900 dark:before:pointer-events-none forced-colors:outline">
                <div
                    className={
                        "grid h-full w-full place-items-start justify-items-center overflow-hidden p-6 py-8 sm:p-8 lg:p-12"
                    }
                >
                    <div className={"flex w-full max-w-sm space-y-8 overflow-hidden p-1"}>
                        <Fieldset className={"w-full"}>
                            <FieldGroup>
                                <div className={"flex flex-col gap-4"}>
                                    {data.customer_oidc ? (
                                        <PrimaryButton
                                            className={"w-full"}
                                            href={`/api/frontend/v1/oidc/begin-login/${token}`}
                                            onClick={() => localStorage.setItem("preferred-tailscale-login", "Oidc")}
                                            external={true}
                                        >
                                            {data.customer_oidc_name}
                                        </PrimaryButton>
                                    ) : (
                                        <Text className={"text-center"}>{t("description.no-login-provider")}</Text>
                                    )}

                                    {/* not supported yet
                                        <Button
                                            outline={true}
                                            className={"w-full"}
                                            href={"/s/tailscale-login/$token/external-tailscale-login"}
                                            onClick={() =>
                                                localStorage.setItem("preferred-tailscale-login", "External")
                                            }
                                        >
                                            {t("button.sign-in-with-external-login")}
                                        </Button>
                                    */}
                                </div>
                            </FieldGroup>
                        </Fieldset>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const Route = createFileRoute("/_static/s/tailscale-login/$token/")({
    component: TailscaleLogin,
    loader: async () => await ApiPublic.auth.enabledTailscaleLogins(),
});
